import React from 'react';
import proImg from './Badge.png';
import FreeImg from '../Free Plan Award.png'; // Importing the free badge image
import enterpriseImg from './Entreprise Badge.png';

const Badge = ({ plan = 'free' }) => {
  const getBadgeStyle = () => {
    switch (plan) {
      case 'enterprise':
        return {
          background: 'linear-gradient(45deg, #0066cc, #003366)', // blue gradient
          boxShadow: '0 0 8px 2px #0066cc',
        };
      case 'pro':
        return {
          background: 'linear-gradient(45deg, #FFD700, #FFA500, #FF4500)', // gold/orange
          boxShadow: '0 0 8px 2px #FFD700',
        };
      case 'free':
      default:
        return {
          background: 'linear-gradient(45deg, #32CD32, #228B22)', // green
          boxShadow: '0 0 8px 2px #32CD32',
        };
    }
  };

  const getBadgeImage = () => {
    switch (plan) {
      case 'enterprise':
        return enterpriseImg;
      case 'pro':
        return proImg;
      case 'free':
      default:
        return FreeImg; // Return the free badge image
    }
  };

  const img = getBadgeImage();

  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center' }}>
      {/* Plan Name Label */}
      <span
        style={{
          padding: '0.25rem 0.75rem',
          borderRadius: '9999px',
          color: '#fff',
          fontWeight: 'bold',
          fontSize: '0.75rem',
          textTransform: 'uppercase',
          letterSpacing: '0.05em',
          userSelect: 'none',
          marginBottom: '8px',
          ...getBadgeStyle(),
        }}
      >
        {plan === 'free' ? 'Free Plan' : plan === 'pro' ? 'Pro Plan' : 'Enterprise Plan'}
      </span>

      {/* Badge Image */}
      {img && (
        <img
          src={img}
          alt={`${plan} Badge`}
          className="badge-img" // Ensure this class is applied for responsive styles
        />
      )}

      {/* Button to Upgrade Plan */}
      <a href="http://localhost:3000/pricing" style={{ marginTop: '12px', textDecoration: 'none' }}>
        <button style={{
          padding: '10px 20px',
          backgroundColor: '#FFD700', // Gold color
          border: 'none',
          borderRadius: '5px',
          color: '#fff',
          fontWeight: 'bold',
          cursor: 'pointer',
          transition: 'background-color 0.3s',
        }}>
          Upgrade to Paid Plan
        </button>
      </a>
      {img && (
        <img
          src={img}
          alt={`${plan} Badge`}
          className="badge-img" // Ensure this class is applied for responsive styles
        />
      )}
    </div>
  );
};

export default Badge;
